
export enum PastClassPunctualityStatusEnum {

  Regular = 1,
  LateClass = 2,
  CriticalLateness = 3,
  Unfulfilled = 4

}